import { cn } from "@/lib/utils";
import { BarControl } from "./BarControl";
import type { BarToggleProps } from "./types";

export function BarToggle<T extends string | number>({
  value,
  options,
  onChange,
}: BarToggleProps<T>) {
  return (
    <BarControl as="div" className="gap-1">
      {options.map((opt) => (
        <button
          key={String(opt.value)}
          onClick={() => onChange(opt.value)}
          className={cn(
            "px-2 sm:px-3 py-1.5 rounded-lg text-xs sm:text-sm font-bold transition-colors",
            value === opt.value
              ? "bg-brand/70 text-white shadow-[0_0_8px_hsl(var(--brand)/0.25)]"
              : "bg-white/[0.04] text-white/50 hover:bg-white/[0.14] hover:text-white/70",
          )}
        >
          {opt.label}
        </button>
      ))}
    </BarControl>
  );
}
